'use client'

import Avatar from '@component/avatar'
import { getColliersClassName } from '@utils'
import { isVillageData } from '@utils/house'
import classNames from 'classnames'
import { first, get } from 'lodash-es'
import { Suspense } from 'react'
import AgentEnquiryButton from '../../info/agents/enquiryButton'

export default function AgentCard({
  data,
  className,
  barClick
}) {
  const agent = first(get(data, 'agents', []))
  const isVillage = isVillageData(data)

  return isVillage
    ? (
      <div className={classNames('flex items-center gap-x-8', className)}>
        {
          data.villageLogoDetail && (
            <Avatar src={data.villageLogoDetail} className='flex-shrink-0' alt={data.villageContactName} width={64} height={64} circle defaultIcon='icon-avatar' />
          )
        }
        {
          data.villageContactName && (
            <div className='text-font text-lg ml-16 whitespace-nowrap'>{data.villageContactName}</div>
          )
        }
        <Suspense>
          <AgentEnquiryButton house={data} className='ml-40 !w-156' onClick={barClick}></AgentEnquiryButton>
        </Suspense>
      </div>
    )
    : agent && (
      <div className={classNames('flex items-center', className)}>
        <Avatar src={agent.icon} className={classNames('flex-shrink-0', getColliersClassName(data.office))} alt={agent.name} width={64} height={64} circle defaultIcon='icon-avatar'></Avatar>
        <div className='text-font text-lg ml-16 whitespace-nowrap'>{agent.name}</div>
        <Suspense>
          <AgentEnquiryButton data={agent} house={data} sendAllAgent className='ml-40 !w-156' onClick={barClick}></AgentEnquiryButton>
        </Suspense>
      </div>
    )
}
